import classNames from 'classnames';
import { SVGPropsIcon } from 'src/types';

export const HeaderBurgerIcon = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      className={classNames(
        'stroke-[2px] text-h_burger cursor-pointer ease-in duration-300',
        props.isGame ? 'w-[35px] h-[35px] md:w-[45px] md:h-[45px]' : 'w-[55px] h-[55px]',
        props.className
      )}
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.5 49.626C39.7198 49.626 49.626 39.7198 49.626 27.5C49.626 15.2802 39.7198 5.37403 27.5 5.37403C15.2802 5.37403 5.37403 15.2802 5.37403 27.5C5.37403 39.7198 15.2802 49.626 27.5 49.626ZM27.5 52C41.031 52 52 41.031 52 27.5C52 13.969 41.031 3 27.5 3C13.969 3 3 13.969 3 27.5C3 41.031 13.969 52 27.5 52Z"
        fill={props.stroke}
      />
      <path d="M15.5353 20.0928H40.6051V22.3718H15.5353V20.0928Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5353 20.0928V22.3718H40.6051V20.0928H15.5353Z"
        fill={props.stroke}
      />
      <path d="M15.5353 26.9302H40.6051V29.2093H15.5353V26.9302Z" fill={props.stroke} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5353 26.9302V29.2093H40.6051V26.9302H15.5353Z"
        fill={props.stroke}
      />
      <path d="M15.5353 33.7677H40.6051V36.0467H15.5353V33.7677Z" fill={props.stroke} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5353 33.7677V36.0467H40.6051V33.7677H15.5353Z"
        fill={props.stroke}
      />
    </svg>
  );
};
